import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import Brand from './Brand';

const ErrorFallback = () => {
    return (
        <div className="seller">
            <div className="seller__error">
                <h2 className="" style={{ fontSize: '14px' }}>
                    Unable to list brands.
                </h2>
            </div>
        </div>
    );
};

const BrandApp = () => {
    const client = new QueryClient({
        defaultOptions: {
            queries: {
                cacheTime: 1000 * 60 * 60 * 24, // 24 hours
                staleTime: 1000 * 30, //30 seconds
            },
        },
    });

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <QueryClientProvider client={client}>
                <ReactQueryDevtools initialIsOpen={false} />
                <Brand />
            </QueryClientProvider>
        </ErrorBoundary>
    );
};

const element = document.getElementById('brand-app') as HTMLElement;
const root = ReactDOM.createRoot(element);

if (element) {
    root.render(
        <React.StrictMode>
            <BrandApp />
        </React.StrictMode>,
    );
}
